* {
  box-sizing: border-box;
}

:host {
  --header-text-color: var(--body-text-arrows-400);
  --header-label-color: var(--blue-layout-103-background);

  display: block;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
}

gz-collapsible-panel.group-panel {
  --panel-header-padding: 7px 0;
  --panel-content-padding: 0;

  &::part(panel-header) {
    position: relative;
    border: none;

    &:hover {
      background-color: transparent;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      left: 11.5px;
      width: 1px;
      height: 8px;
      background-color: var(--chart-104-pressed);
      z-index: -1;
    }

    &::before {
      top: 0;
    }

    &::after {
      bottom: 0;
    }
  }

  &:first-of-type {
    &::part(panel-header) {
      &::before {
        height: 0;
      }
    }
  }

  &:not([isOpen]):last-of-type {
    &::part(panel-header) {
      &::after {
        height: 0;
      }
    }
  }
}

.header {
  font-size: var(--body-size-small);
  font-family: var(--font-family);
  color: var(--header-text-color);
  background-color: var(--header-label-color);
  padding: 0 calc(1.5 * var(--spacer));
  height: calc(3 * var(--spacer));
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  max-width: fit-content;
  cursor: pointer;

  .name {
    font-weight: 600;
    margin-right: 4px;
  }
}

.header-container {
  position: relative;
  border: none;

  &:first-of-type {
    &::before {
      height: 0;
    }
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 11.5px;
    width: 1px;
    height: 8px;
    opacity: 0.6;
    background-color: var(--chart-101-pressed-dividers);
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
  }
}
